import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

declare var $: any;

@Pipe({ name: 'reverse' })

export class ReversePipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
  }
}

@Pipe({ name: "sort" })
export class ArraySortPipe  implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}


@Pipe({name: 'groupBy'})
export class GroupByPipe implements PipeTransform {
  transform(collection: any[], property: string): any[] {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if(!collection) {
        return null;
    }

    const groupedCollection = collection.reduce((previous, current)=> {
        if(!previous[current[property]]) {
            previous[current[property]] = [current];
        } else {
            previous[current[property]].push(current);
        }

        return previous;
    }, {});

    // this will return an array of objects, each object containing a group of objects
    return Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
  }
}


@Pipe({name: 'safe'})
export class SafePipe implements PipeTransform {

    constructor(protected sanitizer: DomSanitizer) {}

    public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        if( value != ""){
            switch (type) {
                case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
                case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
                case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
                case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
                case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
                default: throw new Error(`Invalid safe type specified: ${type}`);
            }
        }
    }
}

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
    transform(items: any[], field : string, value : string): any[] {  
        if (!items) return [];
        if (!value || value.length == 0) return items;
        return items.filter(it => 
            it[field].toLowerCase().indexOf(value.toLowerCase()) !=-1);
    }
}

@Pipe({ name: 'disponible' })
export class DisponiblePipe implements PipeTransform {
    transform(collection: any[], disponible: boolean): any[] {
        return collection.filter(it => it.disponible == disponible)
    }
}

export interface User{
    session:boolean,
    username:string,
    security:any,
    nombre:string,
    saldo:string,
    puntos:string,
    suscrito:boolean,
    divisa:string,
    totalProductos:number
}

export interface Select{
    id:number,
    nombre:string,
    options:any
}

export interface Alerta{
	mensaje:string,
	titulo:string,
	estilo:string,
	icono:string
}

export class PhoneNumber {
    country: string;
    area: string;
    prefix: string;
    line: string;
    get e164() {
        const num = this.country + this.area + this.prefix + this.line
        return `+${num}`
    }
}

export interface ItemProducto{

    id:number,
    nombre:string,
    precio:number,
    divisa:any,
    hasDescuento:boolean,
    descuento:number,
    fotografia:any,
    descripcion:string

}

export class Metatags{

    title:string;
    description:string;
    image:string;
    url:string;
    robots:string;
    keywords:string;
    language:string;
    author:string;
    type:string;
}

export interface Producto{

    id:number,
    descripcionCorta:string,
    descripcionLarga:string,
    ​​inventario:any[],
    caracteristicas:any[],
    marca:string,
    metaDescripcion:string,
    divisa:any,
    modelo:string,
    nombre:string,
    onWishlist:boolean,
    unidad:any

}

export class Direccion{
    id:number;
    calle:string;
    exterior:string;
    interior:string;
    codigoPostal:string;
    colonia:Select;
    municipio:string;
    estado:string;
    pais:string;
    ciudad:string;
    longitud:string;
    latitud:string;
    valido:boolean;
    guardar:boolean;
    referencia:string;
}

export class Base64 {
    // private property
    _keyStr:string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

// public method for encoding
    public encode(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = this._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
            this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
            this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

        }

        return output;
    }

    // public method for decoding
    public decode(input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = this._utf8_decode(output);

        return output;

    }

    // private method for UTF-8 encoding
    _utf8_encode(string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    }

    // private method for UTF-8 decoding
    _utf8_decode(utftext) {
        let string = "";
        let  i = 0;
        let  c = 0;
        let  c1 = 0;
        let  c2 = 0;
        let  c3 = 0;

        while ( i < utftext.length ) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }
        return string;
    }
}



export class addZoom{

    target:any;
    active:boolean;

    public fnInit(newTarget){
        this.target = newTarget;
        this.active = true;
    }

    public fnRun(){
        let newThis = this;
        let container:any = document.getElementById(this.target);
        let imgsrc:any = container.currentStyle || window.getComputedStyle(container, "false");
        imgsrc = imgsrc.backgroundImage.slice(4, -1).replace(/"/g, "");
        let img:any = new Image();

        img.src = imgsrc;
        img.onload = function () {
            var imgWidth = img.naturalWidth,
            imgHeight = img.naturalHeight,
            ratio = imgHeight / imgWidth,
            percentage = ratio * 100 + '%';

            container.onmousemove = function (e) {
                if( newThis.active ){
                    var boxWidth = container.clientWidth,
                    xPos = e.pageX - this.offsetLeft,
                    yPos = e.pageY - this.offsetTop,
                    xPercent = xPos / (boxWidth / 100) + '%',
                    yPercent = yPos / (boxWidth * ratio / 100) + '%';

                    Object.assign(container.style, {
                        backgroundPosition: xPercent + ' ' + yPercent,
                        backgroundSize: (imgWidth * 1) + 'px'
                    });
                }
            };

            container.onmouseleave = function (e) {
                Object.assign(container.style, {
                    backgroundPosition: 'center',
                    backgroundSize: 'contain'
                });
            };
        }
    }

    public fnStop(){
        this.active = false;
    }

};

export function ValidarPassword(password:string):boolean {
    const regex = /(?=.*[@$!%.*#?&])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*.#?&]{8,20}/;
    return regex.test(password);
};
